<template>
    <div class="pdf_generation_main">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <pdfGenerationConfigDialog :settings="pdfGenerationConfigDialogSettings"></pdfGenerationConfigDialog>
        <b-button variant="secondary" block @click="generatePdfClick()" style="width: 300px;">
            Generate PDF
        </b-button>
        <div class="row_wrapper">
            <div class="templates_list_wrapper">
                <div class="list_action_btn" @click="onCreateNewTemplateClick()">Create new</div>
                <div class="list_action_btn" @click="onSaveTemplateClick()">Save
                    {{ (activeTemplate) ? 'current' : 'new' }}
                </div>
                <div class="links_list">
                    <div v-for="(item, index) in templates" :key="index" :id="`template-${index}`"
                         class="template_list_item"
                         :class="{active: activeTemplate && activeTemplate.id == item.id}">
                        <input type="text" v-model="item.name"
                               v-if="editNameTemplate && editNameTemplate.id == item.id"
                               :id="`template_name_md-input-${item.id}`" class="name"/>
                        <div class="name" @click="onTemplateItemClick(item)" v-else><span>{{ item.name }}</span></div>
                        <img @click="onTemplateItemSaveNameClick(item)"
                             v-if="editNameTemplate && editNameTemplate.id == item.id"
                             src="@/assets/icons/ic_content-save.svg"/>
                        <div class="menu">
                            <b-dropdown no-caret class="template_d">
                                <b-dropdown-item
                                    @click.stop="onTemplateItemEditClick(item)"
                                    v-if="!editNameTemplate || editNameTemplate.id != item.id">
                                    <img src="@/assets/icons/ic_edit.svg">
                                    <span>Edit name</span>
                                </b-dropdown-item>
                                <b-dropdown-item
                                    @click.stop="onTemplateItemDuplicateClick(item)">
                                    <img src="@/assets/icons/ic_duplicate.svg">
                                    <span>Duplicate</span>
                                </b-dropdown-item>
                                <b-dropdown-item @click.stop="onTemplateItemDeleteClick(item)">
                                    <img src="@/assets/icons/ic_delete.svg">
                                    <span>Delete template</span>
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content_items_list_wrapper">
                <div class="links_list">
                    <div class="template_list_item header-item">
                        <div class="name"><span>Item name</span></div>
                        <div class="z-index-value"><span>z-index</span></div>
                    </div>
                    <div v-for="(item, index) in items" :key="index" :id="`content-item-${index}`"
                         class="template_list_item"
                         v-if="item.position"
                         :class="{active: item == editingItem}">
                        <div class="name" @click="onContentListItemClick(item)"><span>{{ item.name }}</span></div>
                        <div class="z-index-value" @click="onContentListItemClick(item)"><span>{{ item.position ? ` ${item.position.zIndex}` : '' }}</span></div>
                    </div>
                </div>
            </div>
            <div class="row_content" id="row" style="
    text-align: center;
    font-weight: 800;
    padding: 0;
    line-height: 1;
    border-spacing: 0;
    margin: 0 auto;"
                 :style="`font-family: ${fontHash}, Nunito, sans-serif;`"
            >
                <div class="wrapper_div"
                     :class="showGrid ? 'grid' : ''"
                     :style="`height: ${items.mainConfig.height}${items.mainConfig.measure};
                 width: ${items.mainConfig.width}${items.mainConfig.measure};
                 background-color: ${getMainBackgroundColor()};
                 background-size: ${items.mainConfig.moveStep}px ${items.mainConfig.moveStep}px;`"
                     style="color: #333132; position: relative; margin: 0;">
                    <div class='pdf_content'>
                        <div v-for="(item, index) in items" :id="index" class="block_item back_img"
                             v-if="index.includes('custom_back_img_')"
                             :style="'top:'+ item.position.top + getItemsMeasure() + ';' +
                          'left:'+ item.position.left + getItemsMeasure() + ';' +
                           'background:' + (item.editingActionData.image.file ? 'none' : '#ff0000') + ';' +
                            'z-index: 0;'"
                             style="position: absolute; min-width: 40px; min-height: 40px;">
                            <img class="no_def_dragging"
                                 :class="updatingClass"
                                 :style="'max-height:'+ item.editingActionData.image.maxHeight + getItemsMeasure() + ';' +
                              'max-width:'+ item.editingActionData.image.maxWidth + getItemsMeasure() + ';' +
                              getItemBorderStyle(item) +
                               getItemCornerRadiusStyle(item)"
                                 style="width: auto; height: auto;"
                                 :src="item.editingActionData.image.file || ''">
                            <pdfGenerationActions
                                :settings="{parentId: index, handleEditClick: handleEdit,
                            handleDeleteClick: handleDelete, changePositionHandler: changePosition,
                            getLatestZIndex: function () { return 0 }, config: items.mainConfig}"/>
                        </div>

                            <div
                                @click="onContentItemClick(item)"
                                v-for="(item, index) in items" :id="index" class="block_item"
                                v-if="index.includes('custom_label_')"
                                :class="updatingClass"
                                style="display: block; position: absolute;"
                                :style="
                                     'font-weight:'+ item.editingActionData.textWeight.value + ';'
                                     + 'white-space: ' + (item.editingActionData.width.value == 0 ? 'nowrap;' : 'normal;')
                                     + 'font-style: ' + (item.editingActionData.italic && item.editingActionData.italic.value ? 'italic;' : 'normal;')
                                     + 'font-size:'+ item.editingActionData.textSize.value + getItemsMeasure() + '; ' +
                          'color:'+ item.editingActionData.textColor.value + ';' +
                          'background-color:'+ item.editingActionData.backgroundColor.value + ';' +
                          getItemWidthStyle(item) +
                          getItemHeightStyle(item) +
                          getItemBorderStyle(item) +
                          getItemCornerRadiusStyle(item) +
                           'top:'+ item.position.top + getItemsMeasure() + '; left:'+ item.position.left + getItemsMeasure() + ';' +
                            'z-index:' + item.position.zIndex + ';'
">
                                {{
                                    item.editingActionData.text.value
                                }}
                                <pdfGenerationActions
                                    :settings="{parentId: index, handleEditClick: handleEdit,
                            handleDeleteClick: handleDelete, changePositionHandler: changePosition,
                            getLatestZIndex: getLastZIndex, config: items.mainConfig}"
                                    :style="''"
                                />
                            </div>
<!--                        -->
                        <div v-for="(item, index) in items" :id="index" class="block_item"
                             v-if="index.includes('custom_img_')"
                             :style="'top:'+ item.position.top + getItemsMeasure() + ';' +
                          'left:'+ item.position.left + getItemsMeasure() + ';' +
                           'background:' + (item.editingActionData.image.file ? 'none' : '#ff0000') + ';' +
                            'z-index:' + item.position.zIndex + ';'"
                             style="position: absolute; min-width: 40px; min-height: 40px;">
                            <img class="no_def_dragging"
                                 @click="onContentItemClick(item)"
                                 :class="updatingClass"
                                 :style="'max-height:'+ item.editingActionData.image.maxHeight + getItemsMeasure() + ';' +
                              'max-width:'+ item.editingActionData.image.maxWidth + getItemsMeasure() + ';' +
                              getItemBorderStyle(item) +
                               getItemCornerRadiusStyle(item)"
                                 style="width: auto; height: auto;"
                                 :src="item.editingActionData.image.file || ''">
                            <pdfGenerationActions
                                :settings="{parentId: index, handleEditClick: handleEdit,
                            handleDeleteClick: handleDelete, changePositionHandler: changePosition,
                            getLatestZIndex: getLastZIndex, config: items.mainConfig}"/>
                        </div>
<!--                        -->
                        <div v-for="(item, index) in items" :id="index" class="block_item"
                             v-if="index.includes('qr_green_')"
                             @click="onContentItemClick(item)"
                             :style="'top:'+ item.position.top + getItemsMeasure() + ';' +
                          'left:'+ item.position.left + getItemsMeasure() + ';' +
                            'z-index:' + item.position.zIndex + ';'"
                             style="position: absolute; min-width: 40px; min-height: 40px;">
                            <img class="no_def_dragging"
                                 :class="updatingClass"
                                 :style="'max-height:'+ item.editingActionData.qr.maxHeight + getItemsMeasure() + ';' +
                              'max-width:'+ item.editingActionData.qr.maxWidth + getItemsMeasure() + ';'"
                                 style="width: auto; height: auto;"
                                 :src="getQRImageUrl(item, 3)">
                            <pdfGenerationActions
                                :settings="{parentId: index, handleEditClick: handleEdit,
                            handleDeleteClick: handleDelete, changePositionHandler: changePosition,
                            getLatestZIndex: getLastZIndex, config: items.mainConfig}"/>
                        </div>
<!--                        -->
                        <div v-for="(item, index) in items" :id="index" class="block_item"
                             v-if="index.includes('qr_yellow_')"
                             @click="onContentItemClick(item)"
                             :style="'top:'+ item.position.top + getItemsMeasure() + ';' +
                          'left:'+ item.position.left + getItemsMeasure() + ';' +
                            'z-index:' + item.position.zIndex + ';'"
                             style="position: absolute; min-width: 40px; min-height: 40px;">
                            <img class="no_def_dragging"
                                 :class="updatingClass"
                                 :style="'max-height:'+ item.editingActionData.qr.maxHeight + getItemsMeasure() + ';' +
                              'max-width:'+ item.editingActionData.qr.maxWidth + getItemsMeasure() + ';'"
                                 style="width: auto; height: auto;"
                                 :src="getQRImageUrl(item, 2)">
                            <pdfGenerationActions
                                :settings="{parentId: index, handleEditClick: handleEdit,
                            handleDeleteClick: handleDelete, changePositionHandler: changePosition,
                            getLatestZIndex: getLastZIndex, config: items.mainConfig}"/>
                        </div>
<!--                        -->
                        <div v-for="(item, index) in items" :id="index" class="block_item"
                             v-if="index.includes('qr_red_')"
                             @click="onContentItemClick(item)"
                             :style="'top:'+ item.position.top + getItemsMeasure() + ';' +
                          'left:'+ item.position.left + getItemsMeasure() + ';' +
                            'z-index:' + item.position.zIndex + ';'"
                             style="position: absolute; min-width: 40px; min-height: 40px;">
                            <img class="no_def_dragging"
                                 :class="updatingClass"
                                 :style="'max-height:'+ item.editingActionData.qr.maxHeight + getItemsMeasure() + ';' +
                              'max-width:'+ item.editingActionData.qr.maxWidth + getItemsMeasure() + ';'"
                                 style="width: auto; height: auto;"
                                 :src="getQRImageUrl(item, 1)">
                            <pdfGenerationActions
                                :settings="{parentId: index, handleEditClick: handleEdit,
                            handleDeleteClick: handleDelete, changePositionHandler: changePosition,
                            getLatestZIndex: getLastZIndex, config: items.mainConfig}"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="action_panel">
            <div class="action_buttons">
                <div class="action_row">
                    <b-form-checkbox v-model="showGrid" style="width: 100px; text-align: center">
                        <span>Grid</span>
                    </b-form-checkbox>
                    <button @click="addLabelClick()" class="btn">Label</button>
                    <button @click="addImageClick()" class="btn">Image</button>
                    <b-form-checkbox v-model="items.mainConfig.show" style="width: 100px; text-align: center">
                        <span>Config</span>
                    </b-form-checkbox>
                </div>
                <div class="action_row">
                    <div @click="addDefaultGreenBlock()" class="btn" style="background: #438348; color: white;">Block
                    </div>
                    <div @click="addDefaultGreenQRBlock()" class="btn" style="background: #438348; color: white;">QR
                    </div>
                    <div @click="addDefaultGreenSmiley()" class="btn" style="background: #438348; color: white;">
                        Smiley
                    </div>
                    <div @click="addDefaultHappyHint()" class="btn" style="background: #438348; color: white;">Hint
                    </div>
                </div>
                <div class="action_row">
                    <div @click="addDefaultYellowBlock()" class="btn" style="background: #eb9a40; color: white;">Block</div>
                    <div @click="addDefaultYellowQRBlock()" class="btn" style="background: #eb9a40; color: white;">QR
                    </div>
                    <div @click="addDefaultYellowSmiley()" class="btn" style="background: #eb9a40; color: white;">
                        Smiley
                    </div>
                    <div @click="addDefaultSosoHint()" class="btn" style="background: #eb9a40; color: white;">Hint
                    </div>
                </div>
                <div class="action_row">
                    <div @click="addDefaultRedBlock()" class="btn" style="background: #9a2d2a; color: white;">Block</div>
                    <div @click="addDefaultRedQRBlock()" class="btn" style="background: #9a2d2a; color: white;">QR
                    </div>
                    <div @click="addDefaultRedSmiley()" class="btn" style="background: #9a2d2a; color: white;">Smiley
                    </div>
                    <div @click="addDefaultSadHint()" class="btn" style="background: #9a2d2a; color: white;">Hint
                    </div>
                </div>
                <div class="action_row">
                    <div @click="addDefaultGreenBlock(true)" class="btn" style="background: #438348; color: white;">Block []</div>
                    <div @click="addDefaultYellowBlock(true)" class="btn" style="background: #eb9a40; color: white;">Block []</div>
                    <div @click="addDefaultRedBlock(true)" class="btn" style="background: #9a2d2a; color: white;">Block []</div>
                </div>
                <div class="action_row">
                    <div @click="addDefaultQuestionText" class="btn">Question</div>
                    <div @click="addDefaultLogo()" class="btn">logo</div>
                    <div @click="addDefaultDescription()" class="btn">Description</div>
                    <div @click="addDefaultQuestionId()" class="btn">ID</div>
                </div>
                <div class="action_row">
                    <div @click="addBackImg()" class="btn">Back img</div>
                </div>
            </div>

            <div class="editing_action_block" v-if="showEditingActionData">
                <div class="row_wrapper">
                    <div @click="onBringToFrontClick()" class="btn">Bring to front</div>
                </div>
                <div class="row_wrapper">
                    <div>
                        <md-field class="response_input_md">
                            <label>Name:</label>
                            <md-input v-model="editingItem.name" type="text"
                                      @change="refreshItemData"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="row_wrapper" v-if="editingActionData.position">
                    <div>
                        <md-field class="response_input_md">
                            <label>Left:</label>
                            <md-input v-model="editingActionData.position.left" type="number"
                                      @change="refreshItemData" :step="items.mainConfig.moveStep"></md-input>
                        </md-field>
                    </div>
                    <div>
                        <md-field class="response_input_md">
                            <label>Top:</label>
                            <md-input v-model="editingActionData.position.top" type="number"
                                      @change="refreshItemData" :step="items.mainConfig.moveStep"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="row_wrapper">
                    <div v-if="editingActionData.text && editingActionData.text.applies">
                        <md-field class="response_input_md">
                            <label>Text:</label>
                            <md-input v-model="editingActionData.text.value"
                                      :type="editingActionData.text.type"
                            ></md-input>
                        </md-field>
                    </div>
                    <div v-if="editingActionData.textSize && editingActionData.textSize.applies"
                         style="max-width: 80px;">
                        <md-field class="response_input_md">
                            <label>Text size:</label>
                            <md-input v-model="editingActionData.textSize.value"
                                      :type="editingActionData.textSize.type"></md-input>
                        </md-field>
                    </div>
                    <div v-if="editingActionData.textWeight && editingActionData.textWeight.applies"
                         style="max-width: 80px;">
                        <span style="font-size: 12px;">Weight:</span>
                        <b-dropdown
                            :text="`${editingActionData.textWeight.value}`"
                            style="height: 30px; padding: 0;"
                            no-caret>
                            <b-dropdown-item v-on:click="editingActionData.textWeight.value=500"><span>500</span></b-dropdown-item>
                            <b-dropdown-item v-on:click="editingActionData.textWeight.value=600"><span>600</span></b-dropdown-item>
                            <b-dropdown-item v-on:click="editingActionData.textWeight.value=700"><span>700</span></b-dropdown-item>
                            <b-dropdown-item v-on:click="editingActionData.textWeight.value=800"><span>800</span></b-dropdown-item>
                            <b-dropdown-item v-on:click="editingActionData.textWeight.value=900"><span>900</span></b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
                <div class="row_wrapper">
                    <div v-if="editingActionData.width && editingActionData.width.applies">
                        <md-field class="response_input_md">
                            <label>Width (0 for wrap content):</label>
                            <md-input v-model="editingActionData.width.value"
                                      :type="editingActionData.width.type"></md-input>
                        </md-field>
                    </div>
                    <div v-if="editingActionData.height && editingActionData.height.applies">
                        <md-field class="response_input_md">
                            <label>Height (0 for wrap content):</label>
                            <md-input v-model="editingActionData.height.value"
                                      :type="editingActionData.height.type"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="row_wrapper">
                    <div v-if="editingActionData.textColor && editingActionData.textColor.applies">
                        <md-field class="response_input_md">
                            <label>Text color:</label>
                            <md-input v-model="editingActionData.textColor.value" type="text" disabled/>
                            <input v-model="editingActionData.textColor.value"
                                   :type="editingActionData.textColor.type"/>
                        </md-field>
                    </div>
                    <div v-if="editingActionData.backgroundColor && editingActionData.backgroundColor.applies">
                        <md-field class="response_input_md">
                            <label>Background color:</label>
                            <md-input v-model="editingActionData.backgroundColor.value" type="text" disabled/>
                            <input v-model="editingActionData.backgroundColor.value"
                                   :type="editingActionData.backgroundColor.type"/>
                        </md-field>
                    </div>
                </div>
                <div v-if="editingActionData.image && editingActionData.image.applies">
                    <div>
                        <input
                            type="file"
                            @change="onFileSelected"
                            accept="image/png, image/jpeg"
                            ref="fileInput"
                        >
                    </div>
                    <div class="row_wrapper">
                        <md-field class="response_input_md">
                            <label>Max width:</label>
                            <md-input v-model="editingActionData.image.maxWidth" type="number"></md-input>
                        </md-field>
                        <md-field class="response_input_md">
                            <label>Max height:</label>
                            <md-input v-model="editingActionData.image.maxHeight" type="number"></md-input>
                        </md-field>
                    </div>
                </div>
                <div v-if="editingActionData.qr && editingActionData.qr.applies">
                    <b-form-checkbox v-model="editingActionData.qr.hideLogo">
                        <span>Hide logo</span>
                    </b-form-checkbox>
                    <div class="row_wrapper">
                        <md-field class="response_input_md">
                            <label>Max width:</label>
                            <md-input v-model="editingActionData.qr.maxWidth" type="number"></md-input>
                        </md-field>
                        <md-field class="response_input_md">
                            <label>Max height:</label>
                            <md-input v-model="editingActionData.qr.maxHeight" type="number"></md-input>
                        </md-field>
                    </div>
                    <div class="row_wrapper">
                        <div>
                            <span style="font-size: 12px;">Type:</span><br>
                            <b-dropdown
                                :text="`${editingActionData.qr.type}`"
                                style="height: 30px; padding: 0;"
                                no-caret>
                                <b-dropdown-item v-on:click="editingActionData.qr.type='feedback_new'" class="drop-item"><span>feedback (new)</span></b-dropdown-item>
                                <b-dropdown-item v-on:click="editingActionData.qr.type='log_new'; editingActionData.qr.hideLogo = true" class="drop-item"><span>log (new)</span></b-dropdown-item>
                                <b-dropdown-item v-on:click="editingActionData.qr.type='custom_url'; editingActionData.qr.hideLogo = true" class="drop-item"><span>custom QR URL</span></b-dropdown-item>
                                <b-dropdown-item v-on:click="editingActionData.qr.type='custom_sr'; editingActionData.qr.hideLogo = true" class="drop-item"><span>custom service request</span></b-dropdown-item>
                                <b-dropdown-item v-on:click="editingActionData.qr.type='service_history'; editingActionData.qr.hideLogo = true" class="drop-item"><span>service history</span></b-dropdown-item>
                                <b-dropdown-item v-on:click="editingActionData.qr.type='pickup'; editingActionData.qr.hideLogo = true" class="drop-item"><span>pickup</span></b-dropdown-item>
                                <b-dropdown-item v-on:click="editingActionData.qr.type='switch'; editingActionData.qr.hideLogo = true" class="drop-item"><span>switch</span></b-dropdown-item>
                                <b-dropdown-item v-on:click="editingActionData.qr.type='grease-trap-service-request'; editingActionData.qr.hideLogo = true" class="drop-item"><span>grease trap service request</span></b-dropdown-item>
                                <b-dropdown-item v-on:click="editingActionData.qr.type='dumpster-rules'; editingActionData.qr.hideLogo = true" class="drop-item"><span>dumpster rules</span></b-dropdown-item>
                                <b-dropdown-item v-on:click="editingActionData.qr.type='service-request'; editingActionData.qr.hideLogo = true" class="drop-item"><span>service request</span></b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                    <div class="row_wrapper" v-if="editingActionData.qr.type == 'custom_url' || editingActionData.qr.type == 'custom_sr'">
                        <md-field class="response_input_md">
                            <label v-if="editingActionData.qr.type == 'custom_url'">QR URL:</label>
                            <label v-if="editingActionData.qr.type == 'custom_sr'">Custom SR type:</label>
                            <md-input v-model="editingActionData.qr.custom_value" type="text"></md-input>
                        </md-field>
                    </div>
                    <div class="row_wrapper">
                        <md-field class="response_input_md" v-if="!editingActionData.qr.backgroundColorTransparent">
                            <label>Background color:</label>
                            <md-input v-model="editingActionData.qr.backgroundColor" type="text" disabled/>
                            <input v-model="editingActionData.qr.backgroundColor"
                                   type="color"/>
                        </md-field>
                        <md-field class="response_input_md" v-if="!editingActionData.qr.colorTransparent">
                            <label>Color:</label>
                            <md-input v-model="editingActionData.qr.color" type="text" disabled/>
                            <input v-model="editingActionData.qr.color"
                                   type="color"/>
                        </md-field>
                    </div>
                    <div class="row_wrapper">
                        <b-form-checkbox v-model="editingActionData.qr.backgroundColorTransparent">
                            <span>Back transparent</span>
                        </b-form-checkbox>
                    </div>
                    <div class="row_wrapper">
                        <b-form-checkbox v-model="editingActionData.qr.colorTransparent">
                            <span>Color transparent</span>
                        </b-form-checkbox>
                    </div>
                </div>
                <div v-if="editingActionData.italic && editingActionData.italic.applies">
                    <b-form-checkbox v-model="editingActionData.italic.value">
                        <span>Italic</span>
                    </b-form-checkbox>
                </div>
                <div v-if="editingActionData.border && editingActionData.border.applies">
                    <b-form-checkbox v-model="editingActionData.border.show">
                        <span>Border</span>
                    </b-form-checkbox>
                    <div class="row_wrapper">
                        <md-field class="response_input_md">
                            <label>Border width:</label>
                            <md-input v-model="editingActionData.border.width" type="number"></md-input>
                        </md-field>
                        <md-field class="response_input_md">
                            <label></label>
                            <input v-model="editingActionData.border.color"
                                   type="color"/>
                        </md-field>
                    </div>
                </div>
                <div v-if="editingActionData.cornerRadius && editingActionData.cornerRadius.applies">
                    <md-field class="response_input_md">
                        <label>Corner radius:</label>
                        <md-input v-model="editingActionData.cornerRadius.value" type="number"></md-input>
                    </md-field>
                </div>
                <div class="row_wrapper">
                    <div>
                        <md-field class="response_input_md">
                            <label>Z-index:</label>
                            <md-input v-model="editingActionData.position.zIndex" type="number"
                                      @change="refreshUpdatingClass"></md-input>
                        </md-field>
                    </div>
                </div>
            </div>

        </div>

        <div class="main_config_panel" v-if="items.mainConfig.show">
            <div class="action_buttons">
                <div class="row_wrapper">
                    <div>
                        <md-field class="response_input_md">
                            <label>Width ({{items.mainConfig.measure}}):</label>
                            <md-input v-model="items.mainConfig.width" type="number"></md-input>
                        </md-field>
                    </div>
                    <div>
                        <md-field class="response_input_md">
                            <label>Height ({{items.mainConfig.measure}}):</label>
                            <md-input v-model="items.mainConfig.height" type="number"></md-input>
                        </md-field>
                    </div>
                    <div>
                        <span style="font-size: 12px;">Measure:</span><br>
                        <b-dropdown
                            :text="`${items.mainConfig.measure}`"
                            style="height: 30px; padding: 0;"
                            no-caret>
                            <b-dropdown-item v-on:click="items.mainConfig.measure='in'"><span>in</span></b-dropdown-item>
                            <b-dropdown-item v-on:click="items.mainConfig.measure='mm'"><span>mm</span></b-dropdown-item>
                            <b-dropdown-item v-on:click="items.mainConfig.measure='px'"><span>px</span></b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
                <div class="row_wrapper">
                    <div>
                        <md-field class="response_input_md">
                            <label>Move step:</label>
                            <md-input v-model="items.mainConfig.moveStep" type="number"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="row_wrapper">
                    <b-form-checkbox v-model="insertNewToZero">
                        <span>Insert new to zero</span>
                    </b-form-checkbox>
                </div>
                <b-form-checkbox v-model="items.mainConfig.backgroundTransparent"><span>Background transparent</span></b-form-checkbox>
                <div class="row_wrapper" v-if="!items.mainConfig.backgroundTransparent">
                    <md-field class="response_input_md">
                        <label>Background color:</label>
                        <md-input v-model="items.mainConfig.backgroundColor" type="text" disabled/>
                        <input v-model="items.mainConfig.backgroundColor"
                               type="color"/>
                    </md-field>
                </div>
                <div class="row_wrapper">
                    <div>
                        <md-field class="response_input_md font_i">
                            <label>Font regular:</label>
                            <md-textarea v-model="items.mainConfig.fontRegular" class="font_input"></md-textarea>
                        </md-field>
                        <div class="upload_font_file_btn" @click="onRegularFontChooseClick">Choose regular font</div>
                        <input
                            style="display: none"
                            type="file"
                            @change="onRegularFontChosen"
                            ref="regularFontInput"
                            accept="font/ttf, application/x-font-ttf, application/x-font-truetype, application/x-font-opentype, application/font-woff, application/font-woff2, application/font-sfnt">
                    </div>
                </div>
                <div class="row_wrapper">
                    <div>
                        <md-field class="response_input_md font_i">
                            <label>Font Bold:</label>
                            <md-textarea v-model="items.mainConfig.fontBold" class="font_input"></md-textarea>
                        </md-field>
                        <div class="upload_font_file_btn" @click="onBoldFontChooseClick">Choose bold font</div>
                        <input
                            style="display: none"
                            type="file"
                            @change="onBoldFontChosen"
                            ref="boldFontInput"
                            accept="font/ttf, application/x-font-ttf, application/x-font-truetype, application/x-font-opentype, application/font-woff, application/font-woff2, application/font-sfnt">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {mapActions, mapMutations, mapState} from "vuex";
import customModalDialog from '@/components/widgets/customModalDialog';
import errorMixin from '@/mixins/errorMixin';
import pdfGenerationActions from "@/components/widgets/pdfGenerationActions";
import pdfGenerationConfigDialog from "@/components/widgets/pdfGenerationConfigDialog";
import configApi from "@/api/config";
import adminPageMixin from "@/mixins/adminPageMixin";

export default {
    name: 'pdfGeneration',
    mixins: [errorMixin, adminPageMixin,],
    components: {
        customModalDialog,
        pdfGenerationActions,
        pdfGenerationConfigDialog,
    },

    data() {
        return {
            customModalSettings: {},
            pdfGenerationConfigDialogSettings: {},
            editNameTemplate: {
                name: null,
            },
            activeTemplate: null,
            selectedFile: null,
            showGrid: false,
            insertNewToZero: false,
            showEditingActionData: false,
            latestZIndex: 1,
            fontHash: 'fontHash',
            items: {
                mainConfig: {
                    show: false,
                    width: 8,
                    height: 4,
                    backgroundColor: '#ffffff',
                    backgroundTransparent: false,
                    moveStep: 2,
                    measure: 'in',
                    fontRegular: '',
                    fontBold: '',
                },
            },
            defaultMainConfig: {
                show: false,
                width: 8,
                height: 4,
                backgroundColor: '#ffffff',
                moveStep: 2,
                measure: 'in',
                fontRegular: '',
                fontBold: '',
            },
            templates: [],
            editingItem: {
                name: '',
            },
            editingActionData: {
                position: {
                  left: 0,
                  top: 0,
                },
                text: {
                    applies: true,
                    value: '',
                },
                textSize: {
                    applies: true,
                    value: 10,
                },
                textWeight: {
                    applies: true,
                    value: 800,
                },
                textColor: {
                    applies: true,
                    value: 10,
                },
                backgroundColor: {
                    applies: true,
                    value: '#00000000',
                },
                image: {
                    applies: true,
                    file: null,
                    maxWidth: 100,
                    maxHeight: 100,
                },
                qr: {
                    applies: true,
                    hideLogo: false,
                    maxWidth: 100,
                    maxHeight: 100,
                    color: '#000000',
                    colorTransparent: false,
                    backgroundColor: '#ffffff',
                    backgroundColorTransparent: false,
                    type: 'feedback_new',
                    custom_value: '',
                },
                border: {
                    applies: true,
                    color: '#000000',
                    width: 1,
                    show: true,
                },
                italic: {
                    applies: true,
                    value: false,
                },
            },
            updatingClass: 'updatingClass',
        }
    },

    props: ['infinity'],


    computed: {
        ...mapState({
            accounts: state => state.closeAccount.accounts
        })
    },
    mounted() {
        this.initAdminPage()
        this.loadTemplates()

        this.setupNewTemplate()
    },
    methods: {

        ...mapActions({
            getStickerTemplate: 'stickerTemplates/getStickerTemplate',
            getStickerTemplates: 'stickerTemplates/getStickerTemplates',
            editStickerTemplateName: 'stickerTemplates/editStickerTemplateName',
            duplicateStickerTemplate: 'stickerTemplates/duplicateStickerTemplate',
            editStickerTemplate: 'stickerTemplates/editStickerTemplate',
            createStickerTemplate: 'stickerTemplates/createStickerTemplate',
            deleteStickerTemplate: 'stickerTemplates/deleteStickerTemplate',
            generatePdfByRangeAction: 'pdf/generatePdfByRange',
        }),

        ...mapMutations({
            setMessageModel: 'setMessageModel',
            setProgressBarTag: 'setProgressBarTag',
        }),

        async refreshAll() {

        },
        async loadTemplates() {
            try {
                const response = await this.getStickerTemplates({})
                this.templates = response.collection
            } catch (e) {
                console.log(e)
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
            }
        },

        async generatePdfClick() {
            // console.log(JSON.stringify(this.items))
            let template = this.getFinalHtmlCode()
            // console.log(template)
            this.pdfGenerationConfigDialogSettings = {
                pdfConfigDialogModel: {
                    sticker_width: this.items.mainConfig.width,
                    sticker_height: this.items.mainConfig.height,
                    measure: this.items.mainConfig.measure,
                    q_id_from: '',
                    q_id_to: '',
                    page_width: 104,
                    page_height: 52,
                    col_count: 1,
                    row_count: 13,
                },
                onConfigSet: (config) => {
                    this.generatePdf(config, template)
                },
            }

        },
        async generatePdf(config, template) {
            let pdfGuid = await this.generatePdfByRangeAction({
                pdfConfig: {
                    q_id_from: config.q_id_from,
                    q_id_to: config.q_id_to,
                    page_width: config.page_width,
                    page_height: config.page_height,
                    col_count: config.col_count,
                    rows_count: config.rows_count,
                    sticker_type: 'custom',
                    show_border: false,
                    mode: 'roeda',
                    measure: this.items.mainConfig.measure,
                    template: encodeURIComponent(template),
                    font_regular: this.items.mainConfig.fontRegular,
                    font_bold: this.items.mainConfig.fontBold,
                }
            })
            let url = `${configApi.baseUrl}/admin/pdf/${pdfGuid}`
            console.log(url)
            window.open(url, '_blank')
        },
        getFinalHtmlCode() {

            let copy = document.getElementById('row').cloneNode(true)
            const boxes = copy.querySelectorAll('.edit_block');
            boxes.forEach(box => {
                box.remove();
            });
            const backImgs = copy.querySelectorAll('.back_img');
            backImgs.forEach(item => {
                item.remove();
            });
            var value = new XMLSerializer().serializeToString(copy)
            return value
        },

        setupNewTemplate() {
            this.resetItems()

            this.addDefaultQuestionId()
            this.addDefaultQuestionText()
            this.addDefaultHappyHint()
            this.addDefaultSosoHint()
            this.addDefaultSadHint()
            this.addDefaultDescription()
            this.addDefaultLogo()
            this.addDefaultGreenSmiley()
            this.addDefaultYellowSmiley()
            this.addDefaultRedSmiley()
            this.addDefaultGreenBlock()
            this.addDefaultYellowBlock()
            this.addDefaultRedBlock()
            this.addDefaultGreenQRBlock()
            this.addDefaultYellowQRBlock()
            this.addDefaultRedQRBlock()
        },
        resetItems() {
            this.items = {
                mainConfig: this.defaultMainConfig
            }
        },

        handleEdit(itemId) {
            console.log(`handleEdit: ${itemId}`)
            console.log(`item: ${this.items[itemId]}`)
            this.showItemEditingActionData(this.items[itemId])
        },
        showItemEditingActionData(item) {
            this.showEditingActionData = true
            let editingActionData = item.editingActionData
            editingActionData.position = item.position
            this.editingActionData = editingActionData
            this.editingItem = item
        },
        handleDelete(itemId) {
            console.log(`handleDelete: ${itemId}`, this.items[itemId])
            console.log(`items before:`, this.items)
            delete this.items[itemId]
            console.log(`items after:`, this.items)
            this.showEditingActionData = true
            this.showEditingActionData = false
        },
        getLastZIndex() {
            return this.latestZIndex++
        },
        changePosition(itemId, left, top) {
            if (left) this.items[itemId].position.left = left
            if (top) this.items[itemId].position.top = top
        },

        async onFileSelected(e) {
            var items = e.target.files || e.dataTransfer.files;
            var item = items[0]
            if (item.type != 'image/png' && item.type != 'image/jpeg') {
                //todo error
                return
            }
            var reader = new FileReader();
            let vm = this
            reader.onload = function (e) {
                vm.editingActionData.image.file = e.target.result
                console.log(vm.editingActionData.image.file)
            };
            reader.readAsDataURL(item)
        },
        addLabelClick() {
            this.addDefaultLabel({
                position: {
                    top: 300,
                    left: 300,
                },
                text: 'New text',
                textSize: 20,
                textColor: '#000000',
            }, true)
        },
        addImageClick() {
            console.log(`addImageClick`)
            this.addDefaultImage({
                position: {
                    top: this.getValueOrZero(200),
                    left: this.getValueOrZero(280),
                    zIndex: this.latestZIndex++,
                },
                maxWidth: 100,
                maxHeight: 100,
            }, true)
        },
        addBackImg() {
            this.addDefaultImage({
                position: {
                    top: 0,
                    left: 0,
                    zIndex: 0,
                },
                maxWidth: 400,
                maxHeight: 400,
            }, true, 'custom_back_img_')
        },
        addDefaultGreenQRBlock() {
            let item = {
                type: 'img',
                name: 'green QR',
                position: {
                    top: this.getValueOrZero(119),
                    left: this.getValueOrZero(79),
                    zIndex: this.latestZIndex++,
                },
                editingActionData: {
                    qr: {
                        applies: true,
                        hideLogo: false,
                        maxWidth: 122,
                        maxHeight: 122,
                        color: '#000000',
                        colorTransparent: false,
                        backgroundColor: '#ffffff',
                        backgroundColorTransparent: false,
                        type: 'feedback_new',
                        custom_value: '',
                    },
                },
            }
            this.items['qr_green_' + (new Date()).getTime() + this.getRandomString()] = item
            this.showItemEditingActionData(item)
        },
        addDefaultYellowQRBlock() {
            let item = {
                type: 'img',
                name: 'yellow QR',
                position: {
                    top: this.getValueOrZero(119),
                    left: this.getValueOrZero(314),
                    zIndex: this.latestZIndex++,
                },
                editingActionData: {
                    qr: {
                        applies: true,
                        hideLogo: false,
                        maxWidth: 122,
                        maxHeight: 122,
                        color: '#000000',
                        colorTransparent: false,
                        backgroundColor: '#ffffff',
                        backgroundColorTransparent: false,
                        type: 'feedback_new',
                        custom_value: '',
                    },
                },
            }
            this.items['qr_yellow_' + (new Date()).getTime() + this.getRandomString()] = item
            this.showItemEditingActionData(item)
        },
        addDefaultRedQRBlock() {
            let item = {
                type: 'img',
                name: 'red QR',
                position: {
                    top: this.getValueOrZero(119),
                    left: this.getValueOrZero(554),
                    zIndex: this.latestZIndex++,
                },
                editingActionData: {
                    qr: {
                        applies: true,
                        hideLogo: false,
                        maxWidth: 122,
                        maxHeight: 122,
                        color: '#000000',
                        colorTransparent: false,
                        backgroundColor: '#ffffff',
                        backgroundColorTransparent: false,
                        type: 'feedback_new',
                        custom_value: '',
                    },
                },
            }
            this.items['qr_red_' + (new Date()).getTime() + this.getRandomString()] = item
            this.showItemEditingActionData(item)
        },
        addDefaultGreenBlock(emptyMiddle = false) {
            let file = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwMCIgaGVpZ2h0PSIxMDAwIiB2aWV3Qm94PSIwIDAgODUgODUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iODUiIGhlaWdodD0iODUiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8xOTA0XzI5ODEpIi8+CiAgICA8ZGVmcz4KICAgICAgICA8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMTkwNF8yOTgxIiB4MT0iMy4zNjkxNiIgeTE9IjUuOTE5OTUiIHgyPSIzLjM2OTE2IiB5Mj0iODQuNjM1NyIKICAgICAgICAgICAgICAgICAgICAgICAgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjNDJBMzQ1Ii8+CiAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzIxODM0MCIvPgogICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICA8L2RlZnM+Cjwvc3ZnPgo='
            if(emptyMiddle) {
                file = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwMCIgaGVpZ2h0PSIxMDAwIiB2aWV3Qm94PSIwIDAgMTAwMCAxMDAwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAgMEgxMDAwVjEwMDBIMFYwWk04ODIuOTc5IDExNy4wMjFIMTE3LjAyMVY4ODIuOTc5SDg4Mi45NzlWMTE3LjAyMVoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl80MzAyXzE1KSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzQzMDJfMTUiIHgxPSIzOS42MzcyIiB5MT0iNjkuNjQ2NSIgeDI9IjM5LjYzNzIiIHkyPSI5OTUuNzE0IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM0MkEzNDUiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMjE4MzQwIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg=='
            }
            this.addDefaultImage({
                name: 'green block',
                position: {
                    top: this.getValueOrZero(100),
                    left: this.getValueOrZero(60),
                    zIndex: this.latestZIndex++,
                },
                file: file,
                maxWidth: 160,
                maxHeight: 160,
            })
        },
        addDefaultYellowBlock(emptyMiddle = false) {
            let file = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwMCIgaGVpZ2h0PSIxMDAwIiB2aWV3Qm94PSIwIDAgODUgODUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iODUiIGhlaWdodD0iODUiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8xOTA0XzI5ODEpIi8+CiAgICA8ZGVmcz4KICAgICAgICA8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMTkwNF8yOTgxIiB4MT0iMy4zNjkxNiIgeTE9IjUuOTE5OTUiIHgyPSIzLjM2OTE2IiB5Mj0iODQuNjM1NyIKICAgICAgICAgICAgICAgICAgICAgICAgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjRkNCNTE3Ii8+CiAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0Y3OTUxRSIvPgogICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICA8L2RlZnM+Cjwvc3ZnPgo='
            if(emptyMiddle) {
                file = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwMCIgaGVpZ2h0PSIxMDAwIiB2aWV3Qm94PSIwIDAgMTAwMCAxMDAwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAgMEgxMDAwVjEwMDBIMFYwWk04ODIuOTc5IDExNy4wMjFIMTE3LjAyMVY4ODIuOTc5SDg4Mi45NzlWMTE3LjAyMVoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl80MzAyXzE3KSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzQzMDJfMTciIHgxPSIzOS42MzcyIiB5MT0iNjkuNjQ2NSIgeDI9IjM5LjYzNzIiIHkyPSI5OTUuNzE0IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNGQ0I1MTciLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRjc5NTFFIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg=='
            }
            this.addDefaultImage({
                name: 'yellow block',
                position: {
                    top: this.getValueOrZero(100),
                    left: this.getValueOrZero(295),
                    zIndex: this.latestZIndex++,
                },
                file: file,
                maxWidth: 160,
                maxHeight: 160,
            })
        },
        addDefaultRedBlock(emptyMiddle = false) {
            let file = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwMCIgaGVpZ2h0PSIxMDAwIiB2aWV3Qm94PSIwIDAgODUgODUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iODUiIGhlaWdodD0iODUiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8xOTA0XzI5ODEpIi8+CiAgICA8ZGVmcz4KICAgICAgICA8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMTkwNF8yOTgxIiB4MT0iMy4zNjkxNiIgeTE9IjUuOTE5OTUiIHgyPSIzLjM2OTE2IiB5Mj0iODQuNjM1NyIKICAgICAgICAgICAgICAgICAgICAgICAgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjRDM0MDI0Ii8+CiAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0E2MUUyMiIvPgogICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICA8L2RlZnM+Cjwvc3ZnPgo='
            if(emptyMiddle) {
                file = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwMCIgaGVpZ2h0PSIxMDAwIiB2aWV3Qm94PSIwIDAgMTAwMCAxMDAwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAgMEgxMDAwVjEwMDBIMFYwWk04ODIuOTc5IDExNy4wMjFIMTE3LjAyMVY4ODIuOTc5SDg4Mi45NzlWMTE3LjAyMVoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl80MzAyXzE4KSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzQzMDJfMTgiIHgxPSIzOS42MzcyIiB5MT0iNjkuNjQ2NSIgeDI9IjM5LjYzNzIiIHkyPSI5OTUuNzE0IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNEMzQwMjQiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjQTYxRTIyIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg=='
            }
            this.addDefaultImage({
                name: 'red block',
                position: {
                    top: this.getValueOrZero(100),
                    left: this.getValueOrZero(534),
                    zIndex: this.latestZIndex++,
                },
                file: file,
                maxWidth: 160,
                maxHeight: 160,
            })
        },
        addDefaultLogo() {
            this.addDefaultImage({
                name: 'logo',
                position: {
                    top: 15,
                    left: 640,
                },
                file: 'data:image/jpeg;base64,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',
                maxWidth: 70,
                maxHeight: 70,
            })
        },
        addDefaultGreenSmiley() {
            this.addDefaultImage({
                name: 'green smiley',
                position: {
                    top: 276,
                    left: 93,
                },
                file: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAP4AAABWCAYAAADv2SvSAAAMlUlEQVR4nO2deZhVZR3HPwwiDaCYiMmiknPRLNwVxzUYXHJj8nHXMkvLtDS1p9IpAzTHzDJzxaVV5TElAzcE9Qoi4r6gAsrNBfeN1BAUhemP77nOeLn3zl3OOe9Zfp/nOc9wl3nPb7jne8/7/t7f0qPpnNH4TC/v5yd+D2wYKWRNYKV3rEauLVvToA11GFSMtYBbgCuAHj6PbRhpowdwDfAvoI+fA6/h41iDgNuAbbzHi4HxPo5vGGnjfOBQ7993A2OBt/0Y2K87/ubAA3SKHmAccKxP4xtG2vgJ8NMuj5uB+4EmPwb3Q/i7IYM2KvLaFcC+PpzDMNLEwcAFRZ7PoBvsyHpPUK/wDwHuAtYp8XpPYDKwc53nMYy0MAaYRGltrgfMBA6o5yT1CP804AbkdSxHI1r7b1HHuQwjDWwH3ETnzlgpGoEpwA9rPVEtwu8JXAj8oYrfWQeYBgyr4XyGkQaGA3cAa1f4/gbg8kx7S3umvaXqHbRqhd8I/BM5HqplCFoWDK7hdw0jyQwF7kHT+Go5A/hHpr2lu5n356hG+AOAO4GDqjlBAU3AdGBgHWMYRpLYAK3Zh9QxxreA2zPtLf0r/YVKhf9lYA6wSy1WFTACuB2o2EjDSCgD0c3Ujy26McC9mfaWoZW8uRLhbwfMBTarx6oCtkfrGV+jkQwjRvQHbkU3Qr/YEpibaW/pdszuhL8PMAv4kh9WFdCM/nATv5E2+gMz8GE/vghDgTmZ9paySTjlhH8sirvv66dVBYzGxG+kiyBFn2dtYHqmveXIUm8oJvwewATgarR1FzQmfiMthCH6PL2A6zLtLb8o9mKPgrTcXsCVwDHB27Ua9wD7A8scnNswgiZM0RdyGXByri37WWpv1zv+WujOe0zIRuUZDWQxb7+RPAbgTvQAJwI3ZdpbPptV54U/CLgX2MuFVV3YEf0HlYr9N4y4MRDt07sSfZ6xQDbT3jIQNNUfhjz3xbLrXPE0sAfwpmtDDKMOhqJoVT+3wuslB4xqAN5ARTOixAgUMDTMsR2GUSsZlK4eJdEDvAC83QB8BLQCC93asxpNwH2oyIdhxImtkeg3dG1IAU8AB+fasivya/wlwDfQ3T9KDEHi9yNU2DDCoAUtnaOWj7IY2C/Xlv0APu/VfwlVy/mfC6vKsC6KZ251bYhhdMOhVJdaGxbvAfvk2rKv5Z8oDOB5HDiQ6JXGbkQFCo53bYhhlOBU4Hq6L6IRNsuB/XNt2fldnywWuXc3cCSwKgyrqqABmAich5XuNqJDT+BSVCMvatflp8AhubbsnMIXSsXqTwZOCNSk2vk5cCMW4mu4px8wFQXIRJHv5dqytxV7oVySzpXAmcHYUzcHoaCIQY7tMNLLxsBsYD/XhpTg1Fxb9ppSL3aXlvsb4Hf+2uMbOwCPeD8NI0x2AR5C23ZRZEKuLXthuTdUUojjdLS2jiKDUahxyfRDw/CZY1FC2fquDSnB+bm27Pju3lSJ8DvQGubaei0KiC8A16Gqv362BDOMrqyJnHhXEz3PfZ6JQNE03EIqrbnXgbL2JtdoUBichuKig6gWZKSbISgoJ6pOPNDN78RcW7ajkjdXU2V3JXAUqsoTVb4OPIZ17jH8Ywy6pppdG1KGScB3KhU9VF9XfwXq6xVl8efX/acTvX1VIz70RN2eZxDd9TxI9Ed3LbJRCbV00omD+HsC56Iy3rU0KTDSzQZI8OPwr6N0ENQkeqj9j4qD+EGJR/OAPV0bYsSGA9A10+LakG6oWfRQ37dZXvxRdviBgnxmAH8Eeju2xYgufYDLgZuJXmZdIZOAo5HfrSbqncasAA73DIk6pwAPE92gC8MdOyIHXs3dZ0NkInWKHvxZv6z0DPmzD2MFzRZI/OOJ7l6sER69gXNQtaeoVcopxkS0pViX6ME/x8VK4PvART6NFyRrIKfNQ8A2jm0x3DESeBRoI5z+EfVyLkqcq3jLrhx+eiw7UPvs8T6OGSRbo7v/eVimX5roB/wJ9YP8mmNbKuVn6AvKN4LYqpgAnBzAuEHQE6X5PoX70uJG8IwF5qPrM8rbdHlWodyA3/s9cFB//MWoZ3fUKvmUYhNgOqrys7FjWwz/aQJuQ7nzUSuAWYqPgUOAvwQxeJDfetehllhRq+FXjgOBBcCvULkvI970Bc4CnkH1JOPCeyj25KagThD0dGcGip+PWvXecjQCZ6Ny40diYb9xpAEllT2HisnEKX7jZZTvPzvIk4Sxznkc2Al4NoRz+clGaNbyADDKrSlGFeyFCrT8FeVtxIl5SCvzu3tjvYTl4HgR/UH3hHQ+PxmJ7J4ObOvYFqM0zXR+TnHcpp0G7Aa8GsbJwvRs/hfFzsch0KcYe6F93ynE88JKKs0oZ2Qu8Z2ZXYpyBD4I64Rhb2msAI5DKbO+BCI4oBWFd04l2jnaSWcX1LxiLnIix5FVwEnAj/EhGq8aXO1lngd8E1jq6Px+MBZddLPQhWdOwOBpQDsv96PWanu7Nacu3kM7DZe4OLnLIIabUXLEfxza4Ae7o6nmfBRS2c+tOYlkbRR0sxBtce3k1py6WYB8R9NdGeA6emk+Ko99p2M7/OArwGXAayhn4atuzUkEW6JU2ddQmO1wt+b4wi1oibjIpRGuhQ9y+u2Dpv9JYC20bnsGLQWO854zKmMdNHN6BHgSpcr2dWqRP3SgPJZWQnTilSIKwgc5Nk5H6/73HdviJ83AVcCbqKHiWOIVTBIWvVF3pMnA62jmtJ1Ti/xlCbq5TSAiTu2oCD/PVPSBz3NtiM80Aoehv+914O/oSy7NYcH9kNivBd5Coj8I9UlIEg+j7V9n6/liRE34IGdfM+rdl0S+iAqX/Bt4F8UFnAAMc2hTWDShratbgbeR2I8iev3k/eIiFJSz2LUhhUS188xy4HjUsvsqknthNKI1X6v3+DkUfTbTO+KU41CMoSioZhQwGmVBpoElwHfRzlUkiarw89yApkrXo+2PpLOpdxzvPX4eVQrKH08RAcdQCfoDW6HPaQe0VZvGFOf7gCOAV1wbUo6oCx/gBWBX4NeoCkkUlydBsYl3HN7luReRt3shmiEsQsujN1AkWJA0oMSXJiCDtjA3Q9tuaRR5Vz5FXvvfEnIUXi3EQfiggh5nogYZ16ALL60M847Wguc/QQkeryIH4rvAO96xFPgQLaGWodDprvRGy45G5HTrhxqRDPB+DkLT9sHE55oJk4Wo8Myjrg2plLh9iHNRrbwLUHFPo5NedH4pGOFxCSrftty1IdUQx2nzUuAHKE77Zce2GOklh4rMnETMRA/xFH6eGahK6mWuDTFSRQcKH94KNWeNJXEWPqie34/QVtFzjm0xks/TyNF8CvKVxJa4Cz/PTORZnsDqjivDqJflwBmoAtP9jm3xhaQIH1SOeDz6ArjbrSlGgpgGjEDbdHEpF98tSRJ+nmeBPVBN8siFShqx4XmUVLWv9+9EkUTh55mMAkzOAj5ybIsRH5YBv0T1FG5xbEtgJFn4oLXZOBRddi0RSYk0IskqVAh2ONCOlo6JJenCz7MY+DawPZB1bIsRPaahwLDjULWfxJMW4ed5DBiDiiI84tgWwz0Poq3gfVECVGpIm/Dz3IGyyA4kZR+4AcATSOzNaCs4daRV+KD1/hQ0xTsMXQxGsnkYfdlvi6b3qSXNws+zCuX9b4vq4z/o1hwjAGahLk4j0Zd96p28JvxOOlAP9WZUK38qdoHEmVVoS3dnVAEoUjXvXGPCL85sVAxzU5QEFOu47JSxFCXRZFAQ11y35kQTE355cigJaBDq5LLArTlGGeahoqWDURLNC27NiTYm/Mr4ALgYRXONBiZh0YBRYBmqyLQrSpOdiDI2jW6IWwWeKDDTO/qj3YBjiH8vt7gxG/gbcCMm9Jow4dfO+6j2/5VoPXkEcCjK5DL850lUbfkGEpg0EzYmfH/IAWd7xwjkVGpF00+jdh5Fuys3ooKWhk+Y8P3nae8Yh0pOtwIHoI4q1jevPB+hclY3I8FHujZ9nDHhB8tLqI3SRUAfFB+wN7AnqheYdjqQN/4utM8+G3OahoIJPzyWoRyBO7zH6yFv9O5oNrA1yf88VgCPo24zs4A5qN2UETJJv9CizDsofHSK97g36qq6PQot3QrYHNXLjyMfo7iHJ1Am5EPo7p7oPPe4YMKPDh8DD3hHnjVQEZEtvJ8ZVChiOLBu2AaWYAlq47UIOTkXoIzHRaitlBFBTPjR5lPgGe8opD9qa7Whd2wArE9n66sB3nv6AH2pvOPw+2hZ8iEKXHqHznZcb6H2XK+g4iavYPvoseT/4RtYBiC2ukEAAAAASUVORK5CYII=',
                maxWidth: 94,
                maxHeight: 32,
            })
        },
        addDefaultYellowSmiley() {
            this.addDefaultImage({
                name: 'yellow smiley',
                position: {
                    top: 276,
                    left: 328,
                },
                file: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQ4AAABWCAYAAAA+G3iLAAAAv0lEQVR4nO3UMRGDUBQAwQdVbGAvgrCHDbpgIM1VzJ/ZVXDVzQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwnm1m5j6P39shwBo+32vb344A1mMcQGYcQGYcQGYcQGYcQGYcQGYcQGYcQGYcQGYcQGYcQGYcQGYcQGYcQGYcQGYcQGYcQGYcQGYcQGYcQGYcQGYcQGYcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/PMAQGUEMlh0VtcAAAAASUVORK5CYII=',
                maxWidth: 94,
                maxHeight: 32,
            })
        },
        addDefaultRedSmiley() {
            this.addDefaultImage({
                name: 'red smiley',
                position: {
                    top: 276,
                    left: 568,
                },
                file: 'data:image/png;base64,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',
                maxWidth: 94,
                maxHeight: 32,
            })
        },
        addDefaultImage(config, showEditBlock = false, label = null) {
            let item = {
                type: 'img',
                name: config.name || ('img_' + Date.now()),
                position: {
                    top: this.getValueOrZero(config.position.top),
                    left: this.getValueOrZero(config.position.left),
                    zIndex: this.latestZIndex++,
                },
                editingActionData: {
                    image: {
                        applies: true,
                        file: config.file,
                        maxWidth: config.maxWidth,
                        maxHeight: config.maxHeight,
                    },
                    border: {
                        applies: true,
                        color: '#000000',
                        width: 1,
                        show: false,
                    },
                    cornerRadius: {
                        applies: true,
                        value: 0,
                    }
                },
            }
            this.items[(label || 'custom_img_') + (new Date()).getTime() + this.getRandomString()] = item
            this.showItemEditingActionData(item)
            if (!showEditBlock) this.showEditingActionData = false
        },
        addDefaultQuestionText() {
            this.addDefaultLabel({
                name: 'question text',
                position: {
                    top: 30,
                    left: 55,
                },
                text: 'How clean is this restroom?',
                textSize: 42,
                textWeight: 900,
                textColor: '#000000',
            })
        },
        addDefaultDescription() {
            this.addDefaultLabel({
                name: 'description',
                position: {
                    top: 348,
                    left: 60,
                },
                text: 'Scan the code with your phone camera to leave an anonymous vote with just one tap',
                textSize: 16,
                textWeight: 700,
                textColor: '#999999',
            })
        },
        addDefaultQuestionId() {
            this.addDefaultLabel({
                name: 'ID',
                position: {
                    top: 355,
                    left: 710,
                },
                text: '9999',
                textSize: 15,
                textWeight: 700,
                textColor: '#000000',
            })
        },
        getValueOrZero(value) {
            return this.insertNewToZero ? 0 : value
        },
        addDefaultHappyHint() {
            this.addDefaultLabel({
                name: 'green hint',
                position: {
                    top: 308,
                    left: 106,
                },
                text: 'happy',
                textSize: 24,
                textWeight: 900,
                textColor: '#438348',
            })
        },
        addDefaultSosoHint() {
            this.addDefaultLabel({
                name: 'yellow hint',
                position: {
                    top: 308,
                    left: 346,
                },
                text: 'so-so',
                textSize: 24,
                textWeight: 900,
                textColor: '#eb9a40',
            })
        },
        addDefaultSadHint() {
            this.addDefaultLabel({
                name: 'red hint',
                position: {
                    top: 308,
                    left: 594,
                },
                text: 'sad',
                textSize: 24,
                textWeight: 900,
                textColor: '#9a2d2a',
            })
        },
        addDefaultLabel(config, showEditBlock = false) {
            let item = {
                type: 'label',
                name: config.name || ('label_' + Date.now()),
                position: {
                    top: this.getValueOrZero(config.position.top),
                    left: this.getValueOrZero(config.position.left),
                    zIndex: this.latestZIndex++,
                },
                editingActionData: {
                    text: {
                        applies: true,
                        value: config.text,
                        type: 'text',
                    },
                    textSize: {
                        applies: true,
                        value: config.textSize,
                        type: 'number',
                    },
                    textWeight: {
                        applies: true,
                        value: config.textWeight || 800,
                    },
                    width: {
                        applies: true,
                        value: 0,
                        type: 'number',
                    },
                    height: {
                        applies: true,
                        value: 0,
                        type: 'number',
                    },
                    textColor: {
                        applies: true,
                        value: config.textColor || '#000000',
                        type: 'color',
                    },
                    backgroundColor: {
                        applies: true,
                        value: config.backgroundColor || '#00000000',
                        type: 'color',
                    },
                    border: {
                        applies: true,
                        color: '#000000',
                        width: 1,
                        show: false,
                    },
                    cornerRadius: {
                        applies: true,
                        value: 0,
                    },
                    italic: {
                        applies: true,
                        value: false,
                    },
                },
            }
            this.items['custom_label_' + (new Date()).getTime() + this.getRandomString()] = item
            this.showItemEditingActionData(item)
            if (!showEditBlock) this.showEditingActionData = false
        },
        getRandomString() {
            return `${Math.floor(Math.random() * 1000)}`;
        },

        getItemsMeasure() {
            // return this.items.mainConfig.measure
            return 'px'
        },

        getItemWidthStyle(item) {
            if (!item.editingActionData.width || item.editingActionData.width.value == 0) {
                return ''
            } else {
                return 'width:' + item.editingActionData.width.value + this.getItemsMeasure() + ';'
            }
        },
        getItemHeightStyle(item) {
            if (!item.editingActionData.height || item.editingActionData.height.value == 0) {
                return ''
            } else {
                let value = item.editingActionData.height.value + this.getItemsMeasure() + ';'
                return 'height:' + value + 'line-height:' + value
            }
        },
        getItemBorderStyle(item) {
            if (item.editingActionData.border && item.editingActionData.border.show) {
                let value = item.editingActionData.border
                return `outline: ${value.width}px solid ${value.color};`
            } else {
                return ''
            }
        },
        getItemCornerRadiusStyle(item) {
            if (item.editingActionData.cornerRadius) {
                let value = item.editingActionData.cornerRadius
                return `border-radius: ${value.value}px;`
            } else {
                return ''
            }
        },
        async onTemplateItemDeleteClick(item) {
            this.customModalSettings = {
                message: `Remove template ${item.name}?`,
                showCancelButton: true,
                okButtonText: 'Remove',
                onOkHandler: () => {
                    this.deleteTemplate(item)
                },
                cancelButtonText: 'Cancel',
            }

        },
        async onTemplateItemDuplicateClick(item) {
            this.customModalSettings = {
                input: {
                    label: 'New template name',
                    value: '',
                },
                item: item,
                showCancelButton: true,
                okButtonText: this.translate('Create'),
                onOkHandler: this.onTemplateItemSaveDuplicateClick,
                cancelButtonText: 'Cancel',
            }
        },
        async deleteTemplate(item) {
            this.setProgressBarTag({
                show: true,
                tag: 'delete_template'
            })
            try {
                const response = await this.deleteStickerTemplate({
                    uid: item.uid,
                })
                this.templates.splice(this.templates.indexOf(item), 1);
                if(this.activeTemplate && this.activeTemplate.uid == item.uid) {
                    this.activeTemplate = null
                    this.setupNewTemplate()
                }
            } catch (e) {
                console.log(e)
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'delete_template'
                })
            }
        },
        async onTemplateItemSaveNameClick(item) {
            this.setProgressBarTag({
                show: true,
                tag: 'save_name'
            })
            try {
                const response = await this.editStickerTemplateName({
                    uid: item.uid,
                    name: item.name
                })
                this.editNameTemplate = null
            } catch (e) {
                console.log(e)
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'save_name'
                })
            }
        },
        async onTemplateItemSaveDuplicateClick(settings) {
            let name = settings.input.value
            let item = settings.item
            if (name == '') {
                this.showErrorModal('Please enter name')
                return
            }
            this.setProgressBarTag({
                show: true,
                tag: 'save_duplicate'
            })
            try {
                const response = await this.duplicateStickerTemplate({
                    uid: item.uid,
                    name: name
                })
                await this.loadTemplates()
                this.activeTemplate = this.templates.find(item => item.uid == response.template.uid)
                this.onTemplateItemClick(this.activeTemplate)
            } catch (e) {
                console.log(e)
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'save_duplicate'
                })
            }
        },
        async onTemplateItemClick(item) {
            this.setProgressBarTag({
                show: true,
                tag: 'load_item'
            })
            try {
                const response = await this.getStickerTemplate({uid: item.uid})
                this.activeTemplate = item
                let template = response.template
                if(!template.data.mainConfig.fontRegular) template.data.mainConfig.fontRegular = ''
                if(!template.data.mainConfig.fontBold) template.data.mainConfig.fontBold = ''
                this.items = template.data
                let largestZIndex = 10
                for (const [key, item] of Object.entries(this.items)) {
                    if(item.position && item.position.zIndex && item.position.zIndex > largestZIndex) {
                        largestZIndex = item.position.zIndex
                    }
                }
                this.latestZIndex = largestZIndex+1
                this.applyViewRegularFont()
            } catch (e) {
                console.log(e)
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'load_item'
                })
            }
        },
        onTemplateItemEditClick(item) {
            this.editNameTemplate = item
            let originalField = document.getElementById(`template_name_md-input-${item.id}`)
            originalField.disabled = false
            originalField.focus()
        },
        onCreateNewTemplateClick() {
            this.customModalSettings = {
                title: 'Attention',
                message: 'You will loose all current changes. Continue?',
                showCancelButton: true,
                okButtonText: 'Create new',
                onOkHandler: () => {
                    this.activeTemplate = null
                    this.setupNewTemplate()
                },
                cancelButtonText: 'Cancel',
            }
        },
        onSaveTemplateClick() {
            if (this.activeTemplate) {
                this.editTemplate()
            } else {
                this.customModalSettings = {
                    input: {
                        label: 'Template name',
                        value: '',
                    },
                    showCancelButton: true,
                    okButtonText: this.translate('Save'),
                    onOkHandler: this.createNewTemplate,
                    cancelButtonText: 'Cancel',
                }
            }
        },
        async editTemplate() {
            this.setProgressBarTag({
                show: true,
                tag: 'edit_template_item'
            })
            try {
                const response = await this.editStickerTemplate({
                    uid: this.activeTemplate.uid,
                    data: this.items,
                })
                this.showErrorModal('Saved')
            } catch (e) {
                console.log(e)
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'edit_template_item'
                })
            }
        },
        async createNewTemplate(settings) {
            let name = settings.input.value
            if (name == '') {
                this.showErrorModal('Please enter name')
                return
            }
            this.setProgressBarTag({
                show: true,
                tag: 'save_new_template'
            })
            try {
                const response = await this.createStickerTemplate({
                    name: name,
                    data: this.items,
                    font_regular: "",
                    font_bold: "",
                })
                this.showErrorModal('Saved')
                await this.loadTemplates()
                this.activeTemplate = this.templates.find(item => item.uid == response.template.uid)
            } catch (e) {
                console.log(e)
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'save_new_template'
                })
            }
        },
        refreshItemData() {
            this.refreshUpdatingClass()

        },

        onRegularFontChooseClick() {
            this.$refs.regularFontInput.click()
        },
        async onRegularFontChosen(event) {
            try {
                let result = await this.handleFontFile(event)
                this.items.mainConfig.fontRegular = result
            } catch (e) {}
            this.$refs.regularFontInput.value = ''
        },
        handleFontFile(event) {
            return new Promise((resolve, reject) => {
                if(!event.target.files || event.target.files.length == 0) {
                    reject("No file chosen");
                }
                let selectedFile = event.target.files[0];
                const reader = new FileReader()
                reader.onload = (e) => {
                    resolve(e.target.result);
                }
                reader.readAsDataURL(selectedFile)
            });

        },
        onBoldFontChooseClick() {
            this.$refs.boldFontInput.click()
        },
        async onBoldFontChosen(event) {
            try {
                let result = await this.handleFontFile(event)
                this.items.mainConfig.fontBold = result
            } catch (e) {
                console.log(`error onBoldFontChosen`, e)
            }
            this.$refs.boldFontInput.value = ''
        },
        applyViewRegularFont() {
            if((!this.items.mainConfig.fontRegular || this.items.mainConfig.fontRegular.trim() == '')
                && (!this.items.mainConfig.fontBold || this.items.mainConfig.fontBold.trim() == '')) {
                this.fontHash = 'Nunito'
                return
            }
            let hash = `font_${new Date().getTime()}`
            console.log(`setup fonts hash ${hash}`)
            if (this.items.mainConfig.fontRegular && this.items.mainConfig.fontRegular.trim() != '') {
                var newStyle = document.createElement('style');
                newStyle.appendChild(document.createTextNode(`\
                  @font-face {\
                      font-family: '${hash}';\
                      font-style: normal;
                      font-weight: 700;
                      src: url(${this.items.mainConfig.fontRegular});\
                  }\
               `));
                document.head.appendChild(newStyle);
            }
            if (this.items.mainConfig.fontBold && this.items.mainConfig.fontBold.trim() != '') {
                var newStyle = document.createElement('style');
                newStyle.appendChild(document.createTextNode(`\
                  @font-face {\
                      font-family: '${hash}';\
                      font-style: normal;
                      font-weight: 900;
                      src: url(${this.items.mainConfig.fontBold});\
                  }\
               `));
                document.head.appendChild(newStyle);
            }
            console.log(`setup fonts finish`)
            this.fontHash = hash
        },
        getMainBackgroundColor() {
            if(this.items.mainConfig.backgroundTransparent) {
                return "#00000000"
            } else {
                return this.items.mainConfig.backgroundColor
            }
        },
        getQRImageUrl(item, rateCount) {
            let color = item.editingActionData.qr.color || '#000000'
            if(color.length == 7) {
                color = color + (item.editingActionData.qr.colorTransparent ? '00' : 'ff')
            }
            let backgroundColor = item.editingActionData.qr.backgroundColor  || '#ffffff'
            if(backgroundColor.length == 7) {
                backgroundColor = backgroundColor + (item.editingActionData.qr.backgroundColorTransparent ? '00' : 'ff')
            }
            let type = item.editingActionData.qr.type || 'feedback_new'
            let customValue = item.editingActionData.qr.custom_value || ''
            let value = `https://api.air-vote.com/admin/qrcode?link=https://air-vote.com&rate_count=${rateCount}&show_logo=${!item.editingActionData.qr.hideLogo}&type=${type}&custom_value=${encodeURIComponent(customValue)}&background=${encodeURIComponent(backgroundColor)}&color=${encodeURIComponent(color)}`
            value = value + '&urlend'
            return value
        },
        onContentItemClick(item) {
            this.showItemEditingActionData(item)
        },
        onContentListItemClick(item) {
            this.showItemEditingActionData(item)
        },
        onBringToFrontClick() {
            if(this.editingActionData && this.editingActionData.position) {
                this.editingActionData.position.zIndex = this.latestZIndex++
                this.refreshUpdatingClass()
            }
        },
        refreshUpdatingClass() {
            this.updatingClass = '' + Date.now()
        },

    }

}
</script>

<style scoped>
* {
    font-family: unset;
}
.pdf_generation_main {
    max-height: calc(100vh - 65px);
    overflow-y: scroll;
}
.row_wrapper {
    font-family: Nunito, sans-serif;
}

.row_content {
    margin-top: 24px !important;
    display: flex;
    width: 100%;
    justify-content: center;
}
.drop-item {
    width: 100%;
}

.grid {
    background-image: linear-gradient(to right, rgb(229, 229, 229) 1px, transparent 1px), linear-gradient(rgb(229, 229, 229) 1px, transparent 1px);
    background-size: 5px 5px;
}

.wrapper_div {
    border: 1px solid black;
}

.no_def_dragging {
    user-drag: none;
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.block_item:hover {
    outline: 1px solid black;
    cursor: pointer;
}

.block_item:hover .edit_block {
    visibility: visible;
}

.action_panel {
    display: flex;
    flex-direction: row;
}

.editing_action_block {
    border: 1px solid black;
    max-width: 500px;
    width: 400px;
    min-width: 250px;
    margin: 20px;
    padding: 16px;
}

.action_buttons {
    border: 1px solid black;
    margin-top: 20px;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
}

.action_buttons .action_row {
    display: flex;
    flex-direction: row;
}

.action_buttons .btn {
    min-width: 80px;
    width: 100px;
    height: 40px;
    /*margin-right: 20px;*/
    background: #eeeeee;
    border: 1px solid white;
    cursor: pointer;
}

.row_wrapper .btn {
    min-width: 80px;
    height: 40px;
    background: #eeeeee;
    border: 1px solid white;
    cursor: pointer;
}
.btn:hover {
    background: #5a5a5a;
    color: white;
}

.row_wrapper {
    display: flex;
    flex-direction: row;
}

.upload_font_file_btn {
    border: 1px solid black;
    padding: 6px;
    margin-left: 12px;
    cursor: pointer;
}
.upload_font_file_btn:hover {
    border: 1px solid #006c74;
    background: #008d97;
    color: white;
}
.response_input_md.font_i {
    margin-bottom: 4px;
}
.templates_list_wrapper {
    max-width: 200px;
    width: 200px;
    min-width: 200px;
    min-height: 200px;
    max-height: 400px;
    overflow: scroll;
    margin-top: 24px;
    margin-left: 16px;
    margin-right: 5px;
    border: 1px solid black;
}
.content_items_list_wrapper {
    max-width: 160px;
    width: 160px;
    min-width: 160px;
    min-height: 200px;
    max-height: 400px;
    overflow: scroll;
    margin-top: 24px;
    margin-left: 5px;
    margin-right: 5px;
    border: 1px solid black;
}

.list_action_btn {
    background: #e3e3e3;
    padding: 8px;
    margin: 4px;
    cursor: pointer;
}

.template_list_item {
    display: flex;
    flex-direction: row;
    padding: 4px;
}

.template_list_item .name {
    width: 100%;
    cursor: pointer;
    height: 22px;
    white-space: nowrap;
    overflow-y: hidden;
    overflow-x: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;
}
.template_list_item .name::-webkit-scrollbar {
    display: none;  /* Safari and Chrome */
}

.template_list_item .z-index-value {
    margin-left: 5px;
    cursor: pointer;
    overflow: visible;
    height: 22px;
    color: #00219b;
    white-space: nowrap;
}
.template_list_item.header-item {
    background: #b8b8b8;
    cursor: default;
    border-bottom: 1px solid black;
}
.template_list_item.header-item:hover {
    background: #b8b8b8;
    cursor: default;
}

.template_list_item:hover {
    background: #f1f1f1;
}

.template_list_item.active {
    background: #e0e0e0;
}

.template_list_item img {
    cursor: pointer;
}
.dropdown.template_d /deep/ button.btn-secondary:before {
    content: '';
    background-image: url("~@/assets/icons/ic_kebab.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: block;
    position: relative;
    left: 0;
    top: 0;
    bottom: 0;
    width: 20px;
    height: 20px;
}
.dropdown.template_d /deep/ button.btn-secondary {
    background: none !important;
    border: 0;
    display: flex;
    align-items: center;
    color: #2F2F2F;
    font-size: 14px;
    padding: 0;
    padding-left: 7px;
    font-weight: 600;
    justify-content: flex-end;
}
.font_input {
    border: 1px solid black !important;
    margin-left: 12px;
}
</style>
